import React, { useCallback, useEffect, useState, createContext, useContext } from 'react';
import { newsArticles as defaultArticles, NewsArticle } from '../data/newsArticles';
// ── Types ──────────────────────────────────────────────
export interface MediaItem {
  id: number;
  url: string;
  name: string;
  size: string;
  date: string;
  folder: string;
}
export interface SiteSettings {
  schoolName: string;
  tagline: string;
  email: string;
  phone: string;
  address: string;
  primaryColor: string;
  accentColor: string;
  logoUrl: string;
  darkModeEnabled: boolean;
  seo: {
    home: {
      title: string;
      description: string;
      keywords: string;
    };
    about: {
      title: string;
      description: string;
      keywords: string;
    };
    admissions: {
      title: string;
      description: string;
      keywords: string;
    };
  };
}
export interface SiteContentContextType {
  // News / Articles
  articles: (NewsArticle & {
    status?: string;
  })[];
  addArticle: (article: NewsArticle & {
    status?: string;
  }) => void;
  updateArticle: (id: string, data: Partial<NewsArticle & {
    status?: string;
  }>) => void;
  deleteArticle: (id: string) => void;
  deleteArticles: (ids: string[]) => void;
  getPublishedArticles: () => NewsArticle[];
  // Media
  mediaItems: MediaItem[];
  addMediaItem: (item: MediaItem) => void;
  deleteMediaItem: (id: number) => void;
  // Settings
  settings: SiteSettings;
  updateSettings: (data: Partial<SiteSettings>) => void;
  updateSeoSettings: (page: string, data: {
    title: string;
    description: string;
    keywords: string;
  }) => void;
}
const defaultSettings: SiteSettings = {
  schoolName: 'Isonyin Grammar School',
  tagline: 'God is our Foundation',
  email: 'info@isonyingrammarschool.edu.ng',
  phone: '+234 (0) 800 000 0000',
  address: 'Isonyin-Ijebu, Ogun State, Nigeria',
  primaryColor: '#1e3a8a',
  accentColor: '#eab308',
  logoUrl: '',
  darkModeEnabled: false,
  seo: {
    home: {
      title: 'Isonyin Grammar School | Official Website',
      description: 'Welcome to Isonyin Grammar School, a prestigious secondary school in Ogun State committed to academic excellence since 1956.',
      keywords: 'Isonyin, Grammar School, Ogun State, Education'
    },
    about: {
      title: 'About Us | Isonyin Grammar School',
      description: 'Learn about the history and mission of Isonyin Grammar School.',
      keywords: 'About, History, Mission'
    },
    admissions: {
      title: 'Admissions | Isonyin Grammar School',
      description: 'Apply to Isonyin Grammar School.',
      keywords: 'Admissions, Apply, Enrollment'
    }
  }
};
const defaultMedia: MediaItem[] = [{
  id: 1,
  url: 'https://cdn.magicpatterns.com/uploads/qNUMAPwjKxXJgQ7Cmi46du/WhatsApp_Image_2026-02-19_at_14.10.24_(1).jpg',
  name: 'students-rally.jpg',
  size: '1.2 MB',
  date: 'Feb 19, 2026',
  folder: 'anniversary'
}, {
  id: 2,
  url: 'https://cdn.magicpatterns.com/uploads/keQ1z5dAhNMgYe2HztvvFc/WhatsApp_Image_2026-02-19_at_14.06.18.jpg',
  name: 'staff-meeting.jpg',
  size: '980 KB',
  date: 'Feb 19, 2026',
  folder: 'anniversary'
}, {
  id: 3,
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/de3EQh38fKgVchW9xJS4du/WhatsApp_Image_2025-10-24_at_10.01.26.jpg',
  name: 'hero-banner.jpg',
  size: '2.4 MB',
  date: 'Oct 24, 2025',
  folder: 'general'
}, {
  id: 4,
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/c8nkRq8o8BbU7KKu56ZSnF/WhatsApp_Image_2025-08-14_at_15.45.37_%285%29.jpg',
  name: 'campus-aerial.jpg',
  size: '3.1 MB',
  date: 'Aug 14, 2025',
  folder: 'campus'
}, {
  id: 5,
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jn44YtV68i3KkaTAFc7QtH/otubu.png',
  name: 'prof-otubu.png',
  size: '450 KB',
  date: 'Nov 10, 2025',
  folder: 'alumni'
}, {
  id: 6,
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZLbes2hxk7MhXzaZ1hXLV/WhatsApp_Image_2025-10-24_at_10.01.19.jpg',
  name: 'alumni-gathering.jpg',
  size: '1.8 MB',
  date: 'Oct 24, 2025',
  folder: 'events'
}, {
  id: 7,
  url: 'https://cdn.magicpatterns.com/uploads/ny9gkWcQrLZfy1eVnzqurw/WhatsApp_Image_2026-03-10_at_19.19.06_(1).jpg',
  name: 'principal-odunaike.jpg',
  size: '850 KB',
  date: 'Nov 07, 2025',
  folder: 'general'
}, {
  id: 8,
  url: 'https://cdn.magicpatterns.com/uploads/7erE9EWw8YDTq8W8H9WSLg/WhatsApp_Image_2026-03-10_at_19.25.54.jpg',
  name: 'principal-ugwu-theresa.jpg',
  size: '750 KB',
  date: 'Mar 10, 2026',
  folder: 'general'
}, {
  id: 9,
  url: 'https://cdn.magicpatterns.com/uploads/fm5aeM6UoSmUd8iyr5whV6/IGS.jpg',
  name: 'igs-70-anniversary-banner.jpg',
  size: '2.1 MB',
  date: 'Mar 17, 2026',
  folder: 'anniversary'
}, {
  id: 10,
  url: 'https://cdn.magicpatterns.com/uploads/uQsM27rbNPREQmqUu3VS3W/IGS_70.jpg',
  name: 'igs-70-wide-banner.jpg',
  size: '1.9 MB',
  date: 'Mar 17, 2026',
  folder: 'anniversary'
}, {
  id: 11,
  url: 'https://cdn.magicpatterns.com/uploads/k2BvjZy7n4KdfdkpLXvwi5/WhatsApp_Image_2026-03-17_at_13.15.58.jpg',
  name: 'igs-70-flyer.jpg',
  size: '1.4 MB',
  date: 'Mar 17, 2026',
  folder: 'anniversary'
}, {
  id: 12,
  url: 'https://cdn.magicpatterns.com/uploads/9SCpHLSdj2gFeMaWvjkG7d/Programme_of_events.jpg',
  name: 'programme-of-events.jpg',
  size: '1.1 MB',
  date: 'Mar 17, 2026',
  folder: 'anniversary'
}, {
  id: 8,
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jA5f2egHsPW6YcMhP4RtXv/WhatsApp_Image_2025-10-24_at_10.01.18_%281%29.jpg',
  name: 'chem-lab.jpg',
  size: '1.5 MB',
  date: 'Oct 24, 2025',
  folder: 'campus'
}];
// ── Helpers ─────────────────────────────────────────────
const STORAGE_KEY_ARTICLES = 'igs_articles';
const STORAGE_KEY_MEDIA = 'igs_media';
const STORAGE_KEY_SETTINGS = 'igs_settings';
function loadFromStorage<T>(key: string, fallback: T): T {
  try {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : fallback;
  } catch {
    return fallback;
  }
}
function saveToStorage(key: string, data: any) {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch {
    // localStorage full or unavailable
  }
}
// ── Context ─────────────────────────────────────────────
const SiteContentContext = createContext<SiteContentContextType | undefined>(undefined);
export const SiteContentProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  // Initialize from localStorage, falling back to defaults
  const [articles, setArticles] = useState<(NewsArticle & {
    status?: string;
  })[]>(() => {
    const stored = loadFromStorage<(NewsArticle & {
      status?: string;
    })[] | null>(STORAGE_KEY_ARTICLES, null);
    if (stored && stored.length > 0) return stored;
    return defaultArticles.map(a => ({
      ...a,
      status: 'published'
    }));
  });
  const [mediaItems, setMediaItems] = useState<MediaItem[]>(() => {
    return loadFromStorage(STORAGE_KEY_MEDIA, defaultMedia);
  });
  const [settings, setSettings] = useState<SiteSettings>(() => {
    return loadFromStorage(STORAGE_KEY_SETTINGS, defaultSettings);
  });
  // Persist to localStorage on every change
  useEffect(() => {
    saveToStorage(STORAGE_KEY_ARTICLES, articles);
  }, [articles]);
  useEffect(() => {
    saveToStorage(STORAGE_KEY_MEDIA, mediaItems);
  }, [mediaItems]);
  useEffect(() => {
    saveToStorage(STORAGE_KEY_SETTINGS, settings);
  }, [settings]);
  // ── Article CRUD ──
  const addArticle = useCallback((article: NewsArticle & {
    status?: string;
  }) => {
    setArticles(prev => [article, ...prev]);
  }, []);
  const updateArticle = useCallback((id: string, data: Partial<NewsArticle & {
    status?: string;
  }>) => {
    setArticles(prev => prev.map(a => a.id === id ? {
      ...a,
      ...data
    } : a));
  }, []);
  const deleteArticle = useCallback((id: string) => {
    setArticles(prev => prev.filter(a => a.id !== id));
  }, []);
  const deleteArticles = useCallback((ids: string[]) => {
    setArticles(prev => prev.filter(a => !ids.includes(a.id)));
  }, []);
  const getPublishedArticles = useCallback(() => {
    return articles.filter(a => !a.status || a.status === 'published');
  }, [articles]);
  // ── Media CRUD ──
  const addMediaItem = useCallback((item: MediaItem) => {
    setMediaItems(prev => [item, ...prev]);
  }, []);
  const deleteMediaItem = useCallback((id: number) => {
    setMediaItems(prev => prev.filter(m => m.id !== id));
  }, []);
  // ── Settings ──
  const updateSettings = useCallback((data: Partial<SiteSettings>) => {
    setSettings(prev => ({
      ...prev,
      ...data
    }));
  }, []);
  const updateSeoSettings = useCallback((page: string, data: {
    title: string;
    description: string;
    keywords: string;
  }) => {
    setSettings(prev => ({
      ...prev,
      seo: {
        ...prev.seo,
        [page]: data
      }
    }));
  }, []);
  return <SiteContentContext.Provider value={{
    articles,
    addArticle,
    updateArticle,
    deleteArticle,
    deleteArticles,
    getPublishedArticles,
    mediaItems,
    addMediaItem,
    deleteMediaItem,
    settings,
    updateSettings,
    updateSeoSettings
  }} data-id="element-665">
      {children}
    </SiteContentContext.Provider>;
};
export const useSiteContent = () => {
  const context = useContext(SiteContentContext);
  if (!context) {
    throw new Error('useSiteContent must be used within a SiteContentProvider');
  }
  return context;
};